export default "__VITE_ASSET__430ce934__"